import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import user from './user';
import loading from './loading';
import menu from './menu';
import menu_enlarged from './menu_enlarged';
import area from './area';

export default history =>
  combineReducers({
    router: connectRouter(history),
    user,
    loading,
    menu,
    menu_enlarged,
    area
  });
